import {html} from '@isceco/widget-library2/external/lit'
import WebComponent from '../../../WebComponent.js'
import GPService from '../../Geschaeftspartner/GPService'
import BerechtigungUtil from '../../../services/BerechtigungUtil'
import Navigation from '../../Navigation/Navigation'

export default class GPVerfuegungSetup extends WebComponent {
  static get properties() {
    return {
      sprache: {type: String},
      elektronisches: {type: Boolean},
      callback: {type: Function}
    }
  }

  constructor() {
    super()
    this.gpService = new GPService()
    this.gpId = new BerechtigungUtil().getActiveProfile().gpExtId
    this.callback = () => navigate({to: Navigation.ROUTES.dashboard.url, allow: true})
  }

  get translationFile() {
    return './views/Dashboard/GP/i18n.json'
  }

  connectedCallback() {
    super.connectedCallback()
    if (this.sprache || !this.gpId) {
      this.render()
    } else {
      Promise.resolve(
        this.gpService.read(this.gpId, 'sprache')
      ).then(sprache => {
        if (typeof sprache === 'string') {
          this.sprache = sprache
        }
        this.render()
      })
    }
  }

  getTemplate() {
    const spracheAuswahl = [
      {value: 'DE', name: this.i18n.translate('versand.anmeldung.input.sprache.de')},
      {value: 'FR', name: this.i18n.translate('versand.anmeldung.input.sprache.fr')},
      {value: 'IT', name: this.i18n.translate('versand.anmeldung.input.sprache.it')}
    ]
    const versandartAuswahl = [
      {value: true, name: this.i18n.translate('versand.anmeldung.input.versandart.elektronische')},
      {value: false, name: this.i18n.translate('versand.anmeldung.input.versandart.briefliche')}
    ]
    return html`
      <isceco-title id="page-title" text="${this.i18n.translate('versand.anmeldung.title')}">
      </isceco-title>
      <p>${this.i18n.translate('versand.anmeldung.infotext')}</p>
      <isceco-form id="versand-konfig-form"
                   submit-button-text="${this.i18n.translate('versand.anmeldung.button.submit')}"
                   @submit="${e => this._handleVersandAnmeldungSubmit(e)}"
      >
        <div slot="form-elements" class="form-container">
          <isceco-radio-group name="sprache" value="${this.sprache}"
                              label="${this.i18n.translate('versand.anmeldung.input.sprache')}"
                              .items="${spracheAuswahl}"
                              required inline
          ></isceco-radio-group>
          <isceco-radio-group name="elektronisches" .value="${this.elektronisches}"
                              label="${this.i18n.translate('versand.anmeldung.input.versandart')}"
                              .items="${versandartAuswahl}"
                              required inline
                              @change="${e => this._handleVersandAuswahlChange(e.detail)}"
          ></isceco-radio-group>
          <isceco-text-input name="vereinbarung"
                             style="display: ${this.elektronisches ? 'block' : 'none'}"
                             label="${this.i18n.translate('versand.anmeldung.input.vereinbarung')}"
                             pattern="^[Oo][Kk]$"
                             pattern-error-text="${this.i18n.translate('versand.anmeldung.input.vereinbarung.pattern.error')}"
                             autocomplete="off" required
          ></isceco-text-input>
        </div>
      </isceco-form>
    `
  }

  _handleVersandAuswahlChange = event => {
    if (event.value === true) {
      document.querySelector('isceco-text-input[name=vereinbarung]').style.display = 'block'
    } else {
      document.querySelector('isceco-text-input[name=vereinbarung]').style.display = 'none'
    }
  }

  _handleVersandAnmeldungSubmit = event => {
    // deactivate submit button
    event.target.setAttribute('disabled', true)
    this.render()
    const form = event.detail
    this.gpService.create(form, `/${this.gpId}/verfuegungversand`)
      .then(() => {
        form.elektronisches
          ? showAlert(this.i18n.translate('versand.anmeldung.elektronisches.alert.success'), "", 'success')
          : showAlert(this.i18n.translate('versand.anmeldung.briefliches.alert.success'), "", 'success')
      })
      .finally(this.callback)
  }

}
customElements.define('eko-frontend-gp-verfuegung-setup', GPVerfuegungSetup)
